// En Home.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/login.scss";
import "../styles/home.scss";
import Navbar from "./navbar";
import ModalNewQuiz from "./modal-new-quiz";
import ModalEditProfile from "./modal-edit-profile";
import { getUserInfoDB } from "../lib/db";

function Home() {
  const [user, setUser] = useState();
  const [questionsData, setQuestionData] = useState();
  const [userInfo, setUserInfo] = useState();
  const [showModalStartQuiz, setShowModalStartQuiz] = useState();
  const [userLang] = useState("es");

  const [userGender, setUserGender] = useState("-");
  const [userAge, setUserAge] = useState("-");
  const [userBusiness, setUserBusiness] = useState("-");
  const [userDepartament, setUserDepartament] = useState("-");
  const [userProgramasTransversalesOp1, setUserProgramasTransversalesOp1] = useState("-");
  const [userProgramasTransversalesOp2, setUserProgramasTransversalesOp2] = useState("-");
  const [userProgramasTransversalesOp3, setUserProgramasTransversalesOp3] = useState("-");
  const [userProgramasTransversalesOp4, setUserProgramasTransversalesOp4] = useState("-");
  const [userProgramasTransversalesOp5, setUserProgramasTransversalesOp5] = useState("-");
  const [userProgramasTransversalesOp6, setUserProgramasTransversalesOp6] = useState("-");
  const [userProgramasTransversalesOp7, setUserProgramasTransversalesOp7] = useState("-");

  const [showModalDepartament, setShowModalDepartament] = useState(false); // Inicializado como falso
  let navigate = useNavigate();

  useEffect(() => {
    let userSession = JSON.parse(sessionStorage.getItem("user_IRT"));
    setUser(userSession);
    let questionsDataSession = JSON.parse(
      sessionStorage.getItem("questions_data_IRT")
    );
    setQuestionData(questionsDataSession.questionsData);
    sessionStorage.removeItem("id_IRT");
    sessionStorage.removeItem("email_IRT");
    sessionStorage.removeItem("isLoading_IRT");
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.state.user) {
      setUser(location.state.user);
      sessionStorage.removeItem("id_IRT");
      sessionStorage.removeItem("email_IRT");
      sessionStorage.removeItem("isLoading_IRT");
      getUserDepartament(
        location.state.user.userId,
      );
    }
    if (location.state.questionsData) {
      setQuestionData(location.state.questionsData);
    }
  }, [location]);


  useEffect(() => {
    if (user && user.userCompanyInfo && questionsData) {
      setUserInfo({
        id: user.userId,
        email: user.userEmail,
        name: user.userName,
        companyName: user.userCompanyInfo.name,
        companyId: user.userCompanyInfo.id,
      });
    }
  }, [user, questionsData]);

  const goToQuiz = (userFormState, userInfo) => {
    
    navigate("/quiz", {
      state: {
        user: {
          userInfo: userInfo,
          userProgramasTransversalesOp1: userProgramasTransversalesOp1,
          userProgramasTransversalesOp2: userProgramasTransversalesOp2,
          userProgramasTransversalesOp3: userProgramasTransversalesOp3,
          userProgramasTransversalesOp4: userProgramasTransversalesOp4,
          userProgramasTransversalesOp5: userProgramasTransversalesOp5,
          userProgramasTransversalesOp6: userProgramasTransversalesOp6,
          userProgramasTransversalesOp7: userProgramasTransversalesOp7,
          userDepartament: userDepartament,
          userAge: userAge,
          userBusiness: userBusiness,
          userGender: userGender,
          userStateForm: userFormState,
        },
        questionsData: questionsData,
      },
    });
  };

  const getUserDepartament = async (userId) => {
    const data = await getUserInfoDB(userId);
    if (Object.values(data).length > 0) {
      setUserProgramasTransversalesOp1(data.programasTransversales1);
      setUserProgramasTransversalesOp2(data.programasTransversales2);
      setUserProgramasTransversalesOp3(data.programasTransversales3);
      setUserProgramasTransversalesOp4(data.programasTransversales4);
      setUserProgramasTransversalesOp5(data.programasTransversales5);
      setUserProgramasTransversalesOp6(data.programasTransversales6);
      setUserProgramasTransversalesOp7(data.programasTransversales7);
      setUserDepartament(data.departament);
      setUserAge(data.age);
      setUserBusiness(data.business);
      setUserGender(data.gender);
    }
  };

  return (
    <div className="home-div">
      <Navbar
        userLang={userLang}
        userName={user?.userName || "Usuario"}
        setShowModalDepartament={setShowModalDepartament}
        isQuizPage={true}
      />
      {showModalStartQuiz && (
        <ModalNewQuiz
          goToQuiz={goToQuiz}
          userInfo={userInfo}
          setShowModalStartQuiz={setShowModalStartQuiz}
          userLang={userLang}
        />
      )}
      {showModalDepartament && (
        <ModalEditProfile
          userInfo={userInfo}
          setShowModalDepartament={setShowModalDepartament}
          userGenderProp={userGender}
          userAgeProp={userAge}
          userBusinessProp={userBusiness}
          userDepartamentProp={userDepartament}
          userProgramasTransversalesOp1Prop={userProgramasTransversalesOp1}
          userProgramasTransversalesOp2Prop={userProgramasTransversalesOp2}
          userProgramasTransversalesOp3Prop={userProgramasTransversalesOp3}
          userProgramasTransversalesOp4Prop={userProgramasTransversalesOp4}
          userProgramasTransversalesOp5Prop={userProgramasTransversalesOp5}
          userProgramasTransversalesOp6Prop={userProgramasTransversalesOp6}
          userProgramasTransversalesOp7Prop={userProgramasTransversalesOp7}
          setUserGenderProp={setUserGender}
          setUserAgeProp={setUserAge}
          setUserBusinessProp={setUserBusiness}
          setUserDepartamentProp={setUserDepartament}
          setUserProgramasTransversalesOp1Prop={setUserProgramasTransversalesOp1}
          setUserProgramasTransversalesOp2Prop={setUserProgramasTransversalesOp2}
          setUserProgramasTransversalesOp3Prop={setUserProgramasTransversalesOp3}
          setUserProgramasTransversalesOp4Prop={setUserProgramasTransversalesOp4}
          setUserProgramasTransversalesOp5Prop={setUserProgramasTransversalesOp5}
          setUserProgramasTransversalesOp6Prop={setUserProgramasTransversalesOp6}
          setUserProgramasTransversalesOp7Prop={setUserProgramasTransversalesOp7}
          userLang={userLang}
        />
      )}

      <div className="form-div">
        <img src="/assets/img/home.png" alt="home" />
        <div className="form-buttons">
          <button
            onClick={() => {
              setShowModalStartQuiz(true);
            }}
            className="btn-primary-m btn-options-quiz"
          >
            {userLang === "es" ? "COMENZAR CUESTIONARIO " : "START QUIZ"}
          </button>
          <button
            onClick={() => {
              goToQuiz("continue", userInfo);
            }}
            className="btn-accent btn-options-quiz"
          >
            {userLang === "es" ? "CONTINUAR CUESTIONARIO " : "CONTINUE QUIZ"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Home;
